module.exports = __webpack_public_path__ + "img/71.1be66784.png";